"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var emojis = require("emoji-unicode-map");

module.exports = Object.keys(emojis.emoji);